// src/components/SubscriptionCanceled.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useAuth } from "../context/AuthContext";

export default function SubscriptionCanceledDesktop() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log(
      "ℹ️ User arrived on subscription canceled page:",
      currentUser?.uid
    );
  }, [currentUser]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <LeftMenu />
      <Box sx={{ width: "90%", ml: 1 }}>
        <HeaderBar
          title={translate("SubscriptionCanceledTitle")}
          subtitle={translate("SubscriptionCanceledMessage")}
          showProjectSelect={false}
          userName={currentUser?.displayName}
          userRole=""
        />
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <PauseCircleOutlineIcon
            sx={{ fontSize: 80, color: "warning.main", mb: 2 }}
          />
          <Typography variant="h4" gutterBottom>
            {translate("SubscriptionCanceledTitle")}
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4 }}>
            {translate("SubscriptionCanceledMessage")}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/app/gotopremium")}
          >
            {translate("RenewSubscription")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
